module.exports = __webpack_public_path__ + "static/media/1.e66f094b.jpeg";